import React from "react";
import { Box, type SxProps, type Theme } from "@mui/material";
import { parseCitations } from "../../../features/narrative-citations/parseCitations";
import {
  renderCitedSegments,
  type CanCite,
} from "../../../features/narrative-citations/renderCitedSegments";
import type { CitationGroup } from "../../../features/narrative-citations/types";

export interface CitedNarrativeProps {
  text: string;
  onCite?: (group: CitationGroup) => void;
  canCite?: CanCite;
  sx?: SxProps<Theme>;
}

export const CitedNarrative: React.FC<CitedNarrativeProps> = ({
  text,
  onCite,
  canCite,
  sx,
}) => {
  const { cleanText, groups } = React.useMemo(
    () => parseCitations(text),
    [text],
  );

  return (
    <Box sx={{ whiteSpace: "pre-wrap", ...sx }}>
      {groups.length > 0
        ? renderCitedSegments(
            cleanText,
            groups,
            onCite,
            "narrative",
            canCite,
          )
        : cleanText || "No value provided"}
    </Box>
  );
};
